import { render, staticRenderFns } from "./KgjtWebsiteNews.vue?vue&type=template&id=480ebaea&scoped=true&"
import script from "./KgjtWebsiteNews.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteNews.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteNews.vue?vue&type=style&index=0&id=480ebaea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ebaea",
  null
  
)

export default component.exports